import { Component, OnDestroy, OnInit } from '@angular/core';
import { EventService } from '../../../services/api/EventService';
import { DashboardService } from '../../../services/api/DashboardService';
import { AdminDashboardModel } from '../../../models/api/AdminDashboardModel';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { EventModel } from '../../../models/api/EventModel';
import { forkJoin, interval, startWith, Subject, takeUntil } from 'rxjs';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-event-dashboard',
  standalone: true,
  imports: [RouterModule, MatIconModule, MatButtonModule, DatePipe],
  templateUrl: './event-dashboard.component.html',
  styleUrl: './event-dashboard.component.scss'
})
export class EventDashboardComponent implements OnInit, OnDestroy {

  public dashboardAdminModel: AdminDashboardModel = new AdminDashboardModel;
  public eventDetail: EventModel = new EventModel;
  public eventID = 0;
  public isLoaded: boolean = false;

  constructor(
    private dashboardService: DashboardService,
    private eventService: EventService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.eventID = Number(this.route.snapshot.paramMap.get('id'));
  }

  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    interval(10000)
      .pipe(
        startWith(0),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.loadData();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadData() {
    forkJoin({
      eventDetail: this.eventService.getEvent(this.eventID),
      dashboardAdminModel: this.dashboardService.getEventDashboard(this.eventID, 24)
    }).subscribe({
      next: ({ eventDetail, dashboardAdminModel }) => {
        this.eventDetail = eventDetail;
        this.dashboardAdminModel = dashboardAdminModel;
        this.isLoaded = true;
      },
      error: (err) => {

      }
    });
  }


  goToTherapists(therapistStatus: number) {

  }

  goToClockedIn() {
    this.router.navigate(['admin', 'events', this.eventID, 'therapists', 'clocked-in']);
  }

  goToOnBreak() {
    this.router.navigate(['admin', 'events', this.eventID, 'therapists', 'on-break']);
  }

  goToOnMassage() {
    this.router.navigate(['admin', 'events', this.eventID, 'therapists', 'on-massage']);
  }

  goToWaiting() {
    this.router.navigate(['admin', 'events', this.eventID, 'therapists', 'waiting']);
  }

  goToAtThisEvent() {
    this.router.navigate(['admin', 'events', this.eventID, 'therapists']);
  }

    goToOverview() {
    this.router.navigate(['admin', 'events', this.eventID, 'therapists', 'all']);
  }

  goToBookings(bookingStatus: number) {
    this.router.navigate(['admin', 'events', this.eventID, 'bookings'], { state: { bookingStatus: bookingStatus } });
  }

}
